export const dateTimePicker = {
  range: {
    'Hoje': 0,
    'Ontem': 1,
    'Este Mês': 2,
    'Este Ano': 3,
    'Semana passada': 4,
    'Mês passado': 5,
  },
  locale: {
    direction: 'ltr',
    format: 'dd/mm/yyyy HH:MM',
    separator: ' - ',
    applyLabel: 'Aplicar',
    cancelLabel: 'Cancelar',
    weekLabel: 'S',
    customRangeLabel: 'Padrão',
    daysOfWeek: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sab'],
    monthNames: ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'],
    firstDay: 0
  }
}

export const perPageAmounts = [
  10,
  50,
  100,
  200
]
